import React, { useEffect, useState } from 'react'
import { TextField as MTextField, SxProps, Theme } from '@mui/material'

type Props = {
  testId?: string
  label: string
  value?: string
  disabled?: boolean
  type?: 'text' | 'number' | 'password'
  fullWidth?: boolean
  sx?: SxProps<Theme>
  variant?: 'standard' | 'outlined' | 'filled'
  onChangeDelay?: number
  onChange: (value: string) => void
}

const TextField = ({
  testId,
  label,
  value: pValue,
  disabled = false,
  type = 'text',
  fullWidth = false,
  sx,
  variant,
  onChangeDelay = 0,
  onChange
}: Props) => {
  const [value, setValue] = useState('')
  const [debouncedValue, setDebouncedValue] = useState('')
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    if (!hasMounted) return

    const timeout = setTimeout(() => {
      setValue(debouncedValue)
    }, onChangeDelay)

    return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, onChangeDelay])

  useEffect(() => {
    if (hasMounted) {
      onChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    if (!hasMounted) {
      setHasMounted(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value

    if (type === 'number') {
      value = value.replace(/\D/g, '')
    }

    if (onChangeDelay > 0) {
      setDebouncedValue(value)
    } else {
      setValue(value)
    }
  }

  return (
    <MTextField
      label={label}
      fullWidth={fullWidth}
      value={pValue || debouncedValue}
      disabled={disabled}
      variant={variant}
      inputProps={{ 'data-testid': testId }}
      sx={sx}
      type={type === 'password' ? 'password' : 'text'}
      onChange={handleChange}
    />
  )
}

export default TextField
